export var RankBonusStateType;
(function (RankBonusStateType) {
    RankBonusStateType["DISABLED"] = "disabled";
    RankBonusStateType["ENABLED"] = "enabled";
    RankBonusStateType["RECEIVED"] = "received";
})(RankBonusStateType || (RankBonusStateType = {}));
//# sourceMappingURL=RankBonusStateType.js.map